export default "__VITE_ASSET__CB1nJ0X8__"